import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import FooterContent from './FooterContent';
import * as O from 'fp-ts/lib/Option';
import { FooterLoginTypeCode, getDefaultPortalStaticContentParam, getFooterContentByParams } from 'Core/ducks/footer';
import {pipe} from 'fp-ts/lib/pipeable';
import { getUserClaims } from 'Shared/utilities/UserProfileUtilities';

type PortalFooterProps = {
};

const PortalFooter = (props: PortalFooterProps) => {
    
    const dispatch = useDispatch();

    const claims = pipe(getUserClaims());
    const [auth, setAuth] = useState(false);

    useEffect(() => {
        const params = getDefaultPortalStaticContentParam();
        if((O.isSome(claims))) {
            params.loginTypeCd = FooterLoginTypeCode.AUTH;
            dispatch(getFooterContentByParams(params));
            setAuth(true);
        }
        else{
            params.loginTypeCd = FooterLoginTypeCode.NON_AUTH;
            dispatch(getFooterContentByParams(params));
            setAuth(false);
        }
    }, []);  

    return (<FooterContent copyRightClass={auth} />);
};

export default PortalFooter;